import React from 'react';

import fetch from '../../fetch';

import moment from 'moment';

import utils from '../../../utils';

import {Modal, Tag} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号', width: 75},
    {key:'topicName', label: '选题名称', width: 100},
    {key:'topicTypeName', label: '选题类型', width: 100},
    {key:'topicFromName', label: '选题来源', width: 90},
    {key:'orgName', label: '专业', width: 80},
    {key:'employeeNames', label: '指导老师', width: 100},
    {key:'studentNames', label: '选题结果', width: 150},
    {key:'userName', label: '选题人', width: 150},
    {key:'status', label: '审核状态', width: 85, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>待提交</Tag>)},
    
]);

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('graduation/legislation/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('graduation/legislation/auditquery?'+ params.join('&'),  keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false,
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const queryTopicFromList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('platform/code/grauation/topicFrom', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

const queryTopicTypeList = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('platform/code/grauation/topicType', keywords)
    .then(response => {
        return response.payload.data;
    }).then(data => {
        return data.map(function(d) {
            return {
                value: +d.codeValue,
                label: d.codeName
            }
        });
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('graduation/legislation/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '提示信息',
                content: (
                    <div>
                        <p>{response.message}</p>
                    </div>
                ),
                okText:"确认",
                onOk() {
                    DataGrid.selections = [];
                },
            });
        }
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('graduation/legislation/update/' + id, data)
    .then(response => {
        Modal.success({
            title: '提示信息',
            content: (
                <div>
                    <p>{response.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {
                DataGrid.selections = [];
            },
        });
        
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('graduation/legislation/delete/', ids)
    .then(response => {
        return response;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.selectData = [];
                                DataGrid.refresh();
                            },
                        });
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'graduation/legislation'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    }else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

const auditLegislation = (id, data) => {
    return fetch.post('graduation/entring/audit/' + id, data)
    .then(response => {
        // debugger
        // Modal.success({
        //     title: '提示信息',
        //     content: (
        //         <div>
        //             <p>{response.message}</p>
        //         </div>
        //     ),
        //     okText:"确认",
        //     onOk() {
        //         DataGrid.selections = [];
                return response;
        //     },
        // });
        
    }).catch(error => {
        Modal.error({
            title: '错误提示',
            content: (
                <div>
                <p>{error.message}</p>
                </div>
            ),
            okText:"确认",
            onOk() {},
        });
    });
}

const selectLegislation = (data) => {
    return fetch.post('graduation/legislation/selectLegislation', data);
}

const selectLegislationBatch = (data) => {
    return fetch.post('graduation/legislation/selectLegislationBatch', data);
}

/**
 * @method getLegislationVo
 * @return {promise}
 */
 const getLegislationVo = (id) => {
    return fetch.get('graduation/legislation/getLegislationVoById/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        console.log('error');
    });
}

export default {
    insertURL: '#/graduation/legislation/insert',
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    columns,
    onSelect,
    onSelectData,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    getSelectionData,
    queryTopicFromList,
    queryTopicTypeList,
    auditLegislation,
    selectLegislation,
    getLegislationVo,
    selectLegislationBatch,
}